import { PptEventParameter } from "./interface";
import info from "./status";
import Viewer from "viewerjs";
import { cr } from "fire-wind-water";
const d = window as any;

class Ppt {
  static modules: { [label: string]: string | any }[] = [];
  viewer = null;
  constructor() {
    this.initSubscribe();
  }
  module(o) {
    const key = `sk_temp_webinar_ppt_${new Date().getTime()}`;
    Ppt.modules.push({
      key,
      model: o,
    });
    return {
      unsubscribe() {
        Ppt.modules = Ppt.modules.filter((d) => {
          return d.key !== key;
        });
      },
    };
  }

  initSubscribe() {
    info.ppt.thirdSubscribe.subscribe((data: any) => {
      switch (data.type) {
        case "skPptInfoChange":
          this.skPptInfoChange(data.data);
          break;
      }
    });
  }

  //初始化 ppt 放到 viewer
  initPPT(data) {
    if (this.viewer) {
      this.viewer.destroy();
      this.viewer = null;
    }
    // 初始化ppt插件
    d.viewer = this.viewer = new Viewer(data.id, {
      inline: true,
      button: false,
      fullscreen: false,
      toolbar: false,
      navbar: false,
      title: false,
      zoomOnWheel: false,
    });
    console.log(this.viewer);
    this.resizePPt();
  }

  //上一页
  prevPager(data) {
    d.Mudu.Room.PPT.GetPageImgUrl(data.val, (url) => {
      const pptTotalPage = d.Mudu.Room.PPT.GetTotalPage();
      const pptIsOpen = d.Mudu.Room.PPT.IsOpen();
      const pptIsAllowTurnPage = d.Mudu.Room.PPT.GetAllowTurnPage();
      const pptCurrentPageIndex = data.val;
      const pptUrl = url;
      //新加订阅消息 ppt 改变
      this.skPptInfoChange({
        pptIsOpen: pptIsOpen, //目睹后端是否打开 显示ppt 开关 bollean
        pptUrl: pptUrl, //目睹后端当前ppt url str
        pptCurrentPageIndex: pptCurrentPageIndex, //目睹后端当前ppt 当前页码数 num
        pptTotalPage: pptTotalPage, //目睹后端当前ppt 总页码数 num
        pptIsAllowTurnPage: pptIsAllowTurnPage, //目睹后端是否允许翻页  bollean
        isHavePpt: true, //当前视频是否有ppt  bollean
      });
    });
  }

  //下一页
  nextPager(data) {
    d.Mudu.Room.PPT.GetPageImgUrl(data.val, (url) => {
      const pptTotalPage = d.Mudu.Room.PPT.GetTotalPage();
      const pptIsOpen = d.Mudu.Room.PPT.IsOpen();
      const pptIsAllowTurnPage = d.Mudu.Room.PPT.GetAllowTurnPage();
      const pptCurrentPageIndex = data.val;
      const pptUrl = url;
      //新加订阅消息 ppt 改变
      this.skPptInfoChange({
        pptIsOpen: pptIsOpen, //目睹后端是否打开 显示ppt 开关 bollean
        pptUrl: pptUrl, //目睹后端当前ppt url str
        pptCurrentPageIndex: pptCurrentPageIndex, //目睹后端当前ppt 当前页码数 num
        pptTotalPage: pptTotalPage, //目睹后端当前ppt 总页码数 num
        pptIsAllowTurnPage: pptIsAllowTurnPage, //目睹后端是否允许翻页  bollean
        isHavePpt: true, //当前视频是否有ppt  bollean
      });
    });
  }

  //放大
  zoomOutBtn(data) {
    d.viewer.zoom(data.val);
  }

  //缩小
  zoomInBtn(data) {
    d.viewer.zoom(data.val);
  }

  //刷新
  resizePPt() {
    if (this.viewer) {
      this.viewer.resize();
    }
  }
  //向外部发消息

  skPptInfoChange(data) {
    console.log("发送播放器状态", data);
    cr.each(Ppt.modules, (d) => {
      if (d.model.skPptInfoChange) {
        d.model.skPptInfoChange(data);
      }
    });
  }

  skPptEvent(o: PptEventParameter) {
    switch (o.type) {
      case "initPPt":
        this.initPPT(o.data);
        break;
      case "onPrev":
        this.prevPager(o.data);
        break;
      case "onNext":
        this.nextPager(o.data);
        break;
      case "onZoomOutBtn":
        this.zoomOutBtn(o.data);
        break;
      case "onZoomInBtn":
        this.zoomInBtn(o.data);
        break;
      case "resizePPt":
        this.resizePPt();
        break;
    }
  }
}

export { Ppt };
